// Ad configuration 
const adConfig = {
  // AdMob test units for development
  testUnits: {
    // Display ad test units
    banner: {
      adClient: 'ca-pub-3940256099942544', // Google test publisher ID
      adSlot: '6300978111', // Test banner ad slot
    },
    interstitial: {
      adClient: 'ca-pub-3940256099942544',
      adSlot: '1033173712', // Test interstitial ad slot
    },
    fullscreen: {
      adClient: 'ca-pub-3940256099942544',
      adSlot: '8691691433', // Test full-page ad slot
    },
    // Video ad test units
    videoInterstitial: {
      adClient: 'ca-pub-3940256099942544',
      adSlot: '8691691433', // Test video interstitial ad slot
      // Sample video ad URL for testing
      testVideoUrl: 'https://storage.googleapis.com/gvabox/media/samples/stock.mp4',
    },
    reward: {
      adClient: 'ca-pub-3940256099942544',
      adSlot: '5224354917', // Test rewarded ad slot
      // Sample video for rewarded ads
      testVideoUrl: 'https://storage.googleapis.com/gvabox/media/samples/android.mp4',
    },
  },
  
  // Production ad units - replace with actual production IDs for production environment
  productionUnits: {
    banner: {
      adClient: 'ca-pub-YOUR_PUBLISHER_ID', 
      adSlot: 'YOUR_BANNER_SLOT',
    },
    interstitial: {
      adClient: 'ca-pub-YOUR_PUBLISHER_ID',
      adSlot: 'YOUR_INTERSTITIAL_SLOT',
    },
    fullscreen: {
      adClient: 'ca-pub-YOUR_PUBLISHER_ID',
      adSlot: 'YOUR_FULLSCREEN_SLOT',
    },
    videoInterstitial: {
      adClient: 'ca-pub-YOUR_PUBLISHER_ID',
      adSlot: 'YOUR_VIDEO_SLOT',
    },
    reward: {
      adClient: 'ca-pub-YOUR_PUBLISHER_ID',
      adSlot: 'YOUR_REWARD_SLOT',
    },
  },
  
  // Ad frequency settings
  frequency: {
    swipesToShowAd: 5, // Show an ad every X swipes
    probabilityOfVideoAd: 0.3, // 30% chance of showing a video ad vs. display ad
    minTimeBetweenAds: 30, // Minimum seconds between ad displays
  },
  
  // Ad targeting settings
  targeting: {
    enabled: true, // Whether to use targeting
    allowPersonalization: true, // Whether to allow personalized ads
  },
  
  // Ad formatting settings
  format: {
    bannerHeight: 90, // Height of banner ads in px
    interstitialTimeout: 5, // Seconds before interstitial can be closed
    videoAdDuration: 15, // Duration for video ads before skip button appears
  }
};

export default adConfig;